import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createElementVNode("h2", { class: "text-lg text-start font-bold mb-3" }, "หมวดหมู่หนัง AV", -1 /* HOISTED */)
  ])))
}